import React, { Component } from 'react';
import Navigation from "./Navigation";
import './Content.css';
import './Spinkit-Bars.css';
import {CSSTransition, TransitionGroup} from "react-transition-group";
import Overview from "./Overview";
import Details from "./Details";
import {connect} from 'react-redux';
import * as actions from "../actions/actions";
import { withRouter } from "react-router";
import { Route } from 'react-router-dom';
import { Link } from 'react-router-dom';

class Content extends Component {
  constructor(props) {
    super(props);
    this.props = props;
  }

  componentDidMount(){
    this.props.selectTile(this.props.match.params.selectedTile);
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.location !== this.props.location){
      this.props.selectTile(nextProps.match.params.selectedTile);
    }
  }

  componentWillUnmount(){

  }

  static renderLoading(isLoading=null){
    if(!isLoading){
      return null;
    }
    return <div className="spinlayer">
        <div className="spinner">
          <div className="rect1"></div>
          <div className="rect2"></div>
          <div className="rect3"></div>
          <div className="rect4"></div>
          <div className="rect5"></div>
        </div>
      </div>;
  }

  static renderError(error){
    if(error){
      return <div id="content">
        <div id="main-info">
          <h1>Sorry, something went wrong</h1>
          <p className="error">{error}</p>
          <p>Please click any image.</p>
        </div>
      </div>;
    }
    return null;
  }

  static renderFooter(){
    return  <div id="footer">
      <ul>
        <li><Link to="/">Home</Link></li>
        <li><Link to="/customers">Kunden</Link></li>
        <li><Link to="/services">Leistungen</Link></li>
        <li><Link to="/projects">Projekte</Link></li>
        <li><Link to="/contact">Impressum</Link></li>
      </ul>
    </div>
  }

  static renderContentTransition(key, content){
    return <TransitionGroup id="main-info">
      <CSSTransition key={key} classNames="nav" appear={true} enter={true} exit={true}
                     timeout={{appear: 300, enter: 300, exit: 500}}>
        <div>
          {content}
        </div>
      </CSSTransition>
    </TransitionGroup>
  }

  render() {
    return <div id="hub">
        <Navigation location={this.props.location} selectedTile={this.props.selectedTile}/>
        <Route path={`${this.props.match.url}/:viewId`} component={Details}/>
        <Route exact path={this.props.match.url} component={Overview}/>
      </div>;
  }
}

const mapStateToProps = (state, props) => {
  return {
    ...props,
    selectedTile: state.selection.tile,
  }
};

const ContentWithRouter = withRouter(connect(
  mapStateToProps,
  actions
)(Content));

export default ContentWithRouter;


// WEBPACK FOOTER //
// ./src/components/Content.js